var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockfull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06726912,0.09585216 C1.42580088,0.09585216 0.09585216,1.42580088 0.09585216,3.06726912 C0.09585216,4.70873736 1.42580088,6.03868608 3.06726912,6.03868608 C4.70873736,6.03868608 6.03868608,4.70873736 6.03868608,3.06726912 C6.03868608,1.42580088 4.70873736,0.09585216 3.06726912,0.09585216 Z M3.75141391,4.29058231 L2.69464385,3.52256688 C2.65750114,3.49500938 2.6359344,3.45187591 2.6359344,3.40634614 L2.6359344,1.38985632 C2.6359344,1.31077829 2.70063461,1.24607808 2.77971264,1.24607808 L3.3548256,1.24607808 C3.43390363,1.24607808 3.49860384,1.31077829 3.49860384,1.38985632 L3.49860384,3.03971162 L4.25943036,3.59325785 C4.32413057,3.63998578 4.33731024,3.72984718 4.29058231,3.79454738 L3.95270345,4.25943036 C3.90597552,4.32293242 3.81611412,4.33731024 3.75141391,4.29058231 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockfull);
export default __webpack_public_path__ + "static/media/clockfull.92a32882be1fa22948745b4f5cef18b0.svg";
export { ForwardRef as ReactComponent };